import { getItemPopupList } from 'src/apis/itemApi';
import { SearchCodeModalForm } from 'src/components/common/form/search/SearchCodeModalForm';
import { SearchSectionForm } from 'src/components/common/form/search/SearchSectionForm';
import { SearchDropDownForm } from 'src/components/common/form/search/SearchDropDownForm';
import { useInfoFormEvents } from 'src/hooks/useInfoFormEvents';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import useUiuxStore from 'src/store/useUiuxStore';
import { InfoCodeSearchFieldConfig } from 'src/types/info-form';
import { defaultTQC5020_R01Filter, useTQC5020_R01Store } from './Store_TQC5020_R01';

interface Props {
	onInspTypeChange: (inspType: string) => void;
}

export const SearchSection_TQC5020_R01 = ({ onInspTypeChange }: Props) => {
	const { TQC5020_R01Filter: itemFilter, setTQC5020_R01Filter: setItemFilter, inspTypeFilter, setInspTypeFilter } = useTQC5020_R01Store();
	const { itemGroupList, inspectionTypeList } = useCommonCodeStore();
	const { setCodeSearchModalProps } = useUiuxStore();

	const handleItemFocusId = 'tqc5020_itemCd_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'itemCd',
			category: '품목',
			focusId: handleItemFocusId,
			responseMapping: {
				itemCd: 'itemCd',
				itemNm: 'itemNm',
			},
			searchFunction: async (searchText: string) => {
				const itemResponse = await getItemPopupList(
					searchText,
					'all',
					itemFilter.itemGroup || 'all',
					'all',
				);
				return itemResponse.data.data.find((value) => value.itemCd === searchText);
			},
			extraFilter: () => ({
				itemCd: itemFilter.itemCd || '',
				itemNm: itemFilter.itemNm || '',
				itemGroup: itemFilter.itemGroup || 'all',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: itemFilter,
		setEditData: setItemFilter,
		defaultData: defaultTQC5020_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'TQC5020_R01_search',
	});

	const handleInspTypeChange = (value: string) => {
		setInspTypeFilter(value);
		onInspTypeChange(value);
	};

	return (
		<SearchSectionForm>
			<SearchDropDownForm
				label="품목그룹"
				value={itemFilter.itemGroup}
				optionList={itemGroupList}
				onChangeItem={(selectedItem) => setItemFilter({ itemGroup: selectedItem?.minorCd || '' })}
			/>
			<SearchCodeModalForm
				label="품목코드"
				value={itemFilter.itemCd}
				valueLabel={itemFilter.itemNm}
				handleFoucsId={handleItemFocusId}
				onChange={getFieldHandlers('itemCd').onChange}
				onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
				onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
			/>
			<SearchDropDownForm
				label="검사구분"
				value={inspTypeFilter}
				optionList={inspectionTypeList}
				onChangeItem={(selectedItem) => handleInspTypeChange(selectedItem?.minorCd || '')}
			/>
		</SearchSectionForm>
	);
};
